import PropTypes from 'prop-types';

import FeedPostAlbumSlider from './FeedPostAlbumSlider';
import FeedPostBlur from './FeedPostBlur';
import Flux from '../../flux/Flux';
import FeedPostNeedAction from './FeedPostNeedAction';
import { postType, postPhotoType, tippingGoalType } from './FeedHelper';
import { VXPay } from '../../utils/VXPay';
import { generateKey } from '../../utils/CommonUtils';
import { Fragment, PureComponent } from 'react';

class FeedPostAlbum extends PureComponent {
	getContent({ photos, isSingleImage }) {
		const needsTippingGoal = this.props.tippingGoal && !this.props.tippingGoal.achieved;
		if ((!Flux.Guest.isLoggedIn() || this.props.needBuy || needsTippingGoal) && !isSingleImage) {
			const slicedPhotos = photos.slice(0, 4);
			const onClick = () => {
				if (!Flux.Guest.isLoggedIn()) {
					VXPay.openSignupOrLogin({ host: this.props.model.id });
				}
			};
			return (
				<div className={'feed-album feed-album--' + slicedPhotos.length} onClick={onClick}>
					{this.props.isOverlay && <FeedPostBlur imgUrl={photos[0].url} isOverlay={this.props.isOverlay} />}
					{slicedPhotos.map((photo, idx) => (
						<div key={generateKey(idx)} className={'feed-album__item-wrapper feed-album__item-wrapper--' + (idx + 1)}>
							{!photo.avsRequired && <img className={'feed-album__item'} srcSet={photo.srcSet} />}
							{photo.avsRequired && <img className={'feed-album__item'} src={Flux.Browser.getAvsPictureUrl()} />}
						</div>
					))}
				</div>
			);
		} else {
			return (
				<div className={'feed-album__item-wrapper' + (this.props.isOverlay ? '' : ' feed-album__item-wrapper--fix')}>
					<FeedPostAlbumSlider
						photos={photos}
						hasBought={this.props.hasBought}
						isSingleImage={isSingleImage}
						id={this.props.id}
						isOverlay={this.props.isOverlay}
						isMobile={this.props.isMobile}
						isTablet={this.props.isTablet}
						liked={this.props.guestState ? this.props.guestState.liked : false}
						imageId={this.props.imageId}
						actorId={this.props.model.id}
						tippingGoal={this.props.tippingGoal}
						type={this.props.type}
						contest={this.props.contest}
					/>
				</div>
			);
		}
	}

	render() {
		const photos = this.props.photos;
		const needAvs = photos.find((photo) => photo.avsRequired);
		if (needAvs && this.props.type !== Flux.Constants.Feed.Types.CONTEST) {
			return <FeedPostNeedAction poster={photos[0].url} actorId={this.props.model.id} needAvs={needAvs} tippingGoal={this.props.tippingGoal} />;
		}

		const isSingleImage = photos.length === 1;

		return <Fragment>{this.getContent({ photos, isSingleImage })}</Fragment>;
	}
}

FeedPostAlbum.propTypes = {
	isOverlay: PropTypes.bool,
	isMobile: PropTypes.bool,
	isTablet: PropTypes.bool,
	needBuy: PropTypes.bool,
	imageId: PropTypes.string,
	photos: PropTypes.arrayOf(PropTypes.shape(postPhotoType)),
	tippingGoal: PropTypes.shape(tippingGoalType),
	...postType,
};

FeedPostAlbum.defaultProps = {
	needBuy: false,
	isOverlay: false,
};

export default FeedPostAlbum;
